import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, Observable, Subscription } from 'rxjs';
import { ConditionalblockInterface } from '../../../../models/interface/condition/conditionalblock.interface';
import { ElementInterface } from '../../../../models/interface/elements/element.interface';
import { EvaluationService } from '../../../../services/evaluation/evaluation.service';
import { QuestionLineInterface } from '../../../../models/interface/elements-question/question-line/question-line.interface';
import { AnswersheetAnswerInterface } from '../../../../models/interface/answersheet-answer.interface';
import { Store } from '@ngrx/store';

/**
 * Component:
 * Represents line element
 */

@Component({
  selector: 'app-elements-lines',
  templateUrl: './elements-lines.component.html',
  styleUrls: ['./elements-lines.component.scss']
})
export class ElementsLinesComponent implements OnInit, OnDestroy {
  public condition: Array<ConditionalblockInterface> = [];
  public evaluation$: Observable<boolean>;
  public hidden$: Observable<boolean>;

  public answers: Array<AnswersheetAnswerInterface> = [];

  private element: QuestionLineInterface | ElementInterface;
  private dynamicAnswers: Array<AnswersheetAnswerInterface> = [];
  private dynamicAnswers$: Observable<Array<AnswersheetAnswerInterface>>;

  private expressionSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private evaluationSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private hiddenSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private pageNumber: number;
  private currentPage: number;

  private subscriptions: Subscription[] = [];

  constructor(
    private evaluationService: EvaluationService,
    private store: Store<{
      dynamicAnswers: Array<AnswersheetAnswerInterface>;
    }>
  ) {
    this.dynamicAnswers$ = store.select('dynamicAnswers');
    this.evaluation$ = this.evaluationSubject.asObservable();
    this.hidden$ = this.hiddenSubject.asObservable();
  }

  @Input()
  set _element(_element: QuestionLineInterface | ElementInterface) {
    this.element = _element;
  }

  @Input()
  set _answers(_answers: Array<AnswersheetAnswerInterface>) {
    if (_answers) {
      this.answers = _answers;
    }
  }

  @Input()
  set _condition(_condition: Array<ConditionalblockInterface>) {
    this.condition = _condition;
  }

  @Input()
  set _page(_page) {
    if (_page) {
      this.pageNumber = _page;
      if (this.currentPage) {
        this.hiddenSubject.next(this.currentPage.toString() !== this.pageNumber.toString());
      }
    }
  }

  @Input()
  set _currentPage(_currentPage) {
    if (_currentPage) {
      this.currentPage = _currentPage;
      if (this.pageNumber) {
        this.hiddenSubject.next(this.currentPage.toString() !== this.pageNumber.toString());
      }
    }
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.dynamicAnswers$.pipe(distinctUntilChanged()).subscribe(dynamicAnswers => {
        this.dynamicAnswers = dynamicAnswers;
        this.evaluationService.evaluateExpression(
          this.expressionSubject,
          this.evaluationSubject,
          this.condition,
          this.element.position,
          this.dynamicAnswers,
          this.dynamicAnswers
        );
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }
}
